import { render } from "./CompaniesTitle.vue?vue&type=template&id=88b0abea"
import script from "./CompaniesTitle.vue?vue&type=script&lang=js"
export * from "./CompaniesTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__